import React, { useEffect, useState } from "react";
import { Badge, Card, Col, Form, Offcanvas, Row, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsKitPreparationServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitPreparationServices";
import { FaLock } from "react-icons/fa";

const ReleaseKitPreparation = ({
  kitData,
  getStudyKitPreparationData,
  Show,
  Hide,
  Title,
  setKitId,
  eiwrsPermission
}) => {
  const { studyId } = useParams()
  const [certificateofAnalysisRef, setCertificateofAnalysisRef] = useState("");
  const [certificateofReleaseRef, setCertificateofReleaseRef] = useState("");
  const [releaseComment, setReleaseComment] = useState("");
  const [checkbox, setCheckbox] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const statusConvertKitPreparation = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Release Kit!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, release it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = kitData?._id;
        userData.studyId = studyId;
        userData.status = "released";
        userData.certificateofAnalysisRef = certificateofAnalysisRef;
        userData.certificateofReleaseRef = certificateofReleaseRef;
        userData.releaseComment = releaseComment;
        userData.mode = StudyMode;
        let data = await eiwrsKitPreparationServices.statusConvertKitPreparation(
          userData
        );
        if (data?.statusCode === 200) {
          getStudyKitPreparationData();
          Hide();
          setCertificateofAnalysisRef("");
          setCertificateofReleaseRef("");
          setReleaseComment("");
          setCheckbox(false);
        }
      }
      setButtonLoader(false);
    });
  };
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="mb-3">
            <Card.Body className="p-3">
              <Row>
                {kitData?.kitNumber &&
                  <Col xs={6}>
                    <div className="text-muted small">Kit Number</div>
                    <div className="fw-semibold">{kitData?.kitNumber}</div>
                  </Col>
                }
                {kitData?.kitType &&
                  <Col xs={6}>
                    <div className="text-muted small">Kit Type</div>
                    <div className="fw-semibold text-capitalize">{kitData?.kitType} Kit</div>
                  </Col>
                }
                {kitData?.siteName &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Depot-Site</div>
                    <div className="fw-semibold">{kitData?.depot}-{kitData?.siteName}</div>
                  </Col>
                }
                {kitData?.batchNumber &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Batch Number</div>
                    <div className="fw-semibold">{kitData?.batchNumber}</div>
                  </Col>
                }
                {kitData?.treatment &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Treatment</div>
                    <div className="fw-semibold">
                      {(eiwrsPermission?.dbpCreateKitPreparation || eiwrsPermission?.liveCreateKitPreparation || eiwrsPermission?.qcCreateKitPreparation || eiwrsPermission?.liveTreatmentUnblinded || eiwrsPermission?.qcTreatmentUnblinded || eiwrsPermission?.dbpTreatmentUnblinded) ?
                        kitData?.treatment
                        :
                        <Badge style={{ width: 70 }} className="bg-danger hstack gap-1"><FaLock /> Blinded</Badge>
                      }
                    </div>
                  </Col>
                }
                {kitData?.expiryDate &&
                  <Col xs={6} className="mt-2">
                    <div className="text-muted small">Expiry Date</div>
                    <div className="fw-semibold">{kitData?.expiryDate}</div>
                  </Col>
                }
                {kitData?.QCComment &&
                  <Col xs={12} className="mt-2">
                    <div className="text-muted small">QC Comment</div>
                    <div className="fw-semibold">{kitData?.QCComment}</div>
                  </Col>
                }
                <Form.Group className="mt-3">
                  <div className="text-muted small mb-2">QC Check List</div>
                  <Form.Check
                    type="checkbox"
                    label="Label verification"
                    disabled
                    checked={kitData?.QCChecklist?.labelVerification}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Kit content verification"
                    disabled
                    checked={kitData?.QCChecklist?.kitContentVerification}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Batch & lot verification"
                    disabled
                    checked={kitData?.QCChecklist?.batchLotVerification}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Expiry verification"
                    disabled
                    checked={kitData?.QCChecklist?.expiryVerification}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Tamper seal verification"
                    disabled
                    checked={kitData?.QCChecklist?.tamperSealVerification}
                  />

                  <Form.Check
                    type="checkbox"
                    label="Barcode scan verification"
                    disabled
                    checked={kitData?.QCChecklist?.barcodeScanVerification}
                  />
                </Form.Group>
              </Row>
            </Card.Body>
          </Card>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Certificate of Analysis Ref
            </Form.Label>
            <Form.Control
              onChange={(e) => setCertificateofAnalysisRef(e.target.value)}
              value={certificateofAnalysisRef}
              className="br3"
              placeholder="Enter Certificate of Analysis Ref"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Certificate of Release Ref
            </Form.Label>
            <Form.Control
              onChange={(e) => setCertificateofReleaseRef(e.target.value)}
              value={certificateofReleaseRef}
              className="br3"
              placeholder="Enter Certificate of Release Ref"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Release Comment
            </Form.Label>
            <Form.Control
              onChange={(e) => setReleaseComment(e.target.value)}
              value={releaseComment}
              className="br3"
              placeholder="Enter Comment"
              as="textarea"
            />
          </Form.Group>
          <Form.Group className="my-1">
            <Form.Check
              onChange={(e) => setCheckbox(e.target.checked)}
              checked={checkbox}
              className="br3"
              label="I, as Qualified Person, authorize release of this kit."
              type="checkbox"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!checkbox || buttonLoader}
            className="updateProfile"
            onClick={(e) => statusConvertKitPreparation(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Releasing...
              </div>
            ) : (
              "Release Kit"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default ReleaseKitPreparation;
